<div
    class="side-nav"
    sideBar
    (mouseenter)="sidenavOpen()"
    (mouseleave)="sidenavClose()"
>
    <div class="side-nav-inner">
        <!-- Company/Branch Header + Switcher -->
        <business-switcher (branchChanged)="branchChanged()" (panelToggled)="onPanelToggled($event)"></business-switcher>

        <ul
            class="side-nav-menu scrollable side-nav-ul"
        >
            <!-- Large Menu -->
            <ng-container *ngFor="let menuItem of largeMenu">
                <li
                    *ngIf="!menuItem.highlightForLeads"
                    (click)="toggleNavigation()"
                    appSecurityTag
                    [securityTags]="menuItem.securityTags"
                    class="nav-item"
                    routerLinkActive="{{ menuItem.routerLinkActive }}"
                    [routerLinkActiveOptions]="
                        menuItem.routerLinkActiveOptions || {
                            exact: menuItem.routerLinkActiveExactStatus
                        }
                    "
                >
                    <a
                        *ngIf="
                            !menuItem.checkVisibility ||
                            (menuItem.checkVisibility && menuItem.visible)
                        "
                        [attr.id]="menuItem.id"
                        [routerLink]="[menuItem.routerLink]"
                        [queryParams]="menuItem.queryParams"
                    >
                        <div class="nav-item-inner">
                            <span class="icon-holder"><lucide-icon [name]="menuItem.icon" [size]="20"></lucide-icon></span>
                            <span class="title">
                                {{
                                    'layout.sidenav.company-labels.' +
                                        menuItem.label
                                        | lowercase
                                        | translate
                                }}
                            </span>
                        </div>
                    </a>
                </li>

                <li
                    *ngIf="menuItem.highlightForLeads"
                    (click)="toggleNavigation()"
                    appSecurityTag
                    [securityTags]="menuItem.securityTags"
                    class="nav-item"
                    [class.active]="clientsModuleActive"
                >
                    <a
                        *ngIf="
                            !menuItem.checkVisibility ||
                            (menuItem.checkVisibility && menuItem.visible)
                        "
                        [routerLink]="[menuItem.routerLink]"
                        [queryParams]="menuItem.queryParams"
                    >
                        <div class="nav-item-inner">
                            <span class="icon-holder"><lucide-icon [name]="menuItem.icon" [size]="20"></lucide-icon></span>
                            <span class="title">
                                {{
                                    'layout.sidenav.company-labels.' +
                                        menuItem.label
                                        | lowercase
                                        | translate
                                }}
                            </span>
                        </div>
                    </a>
                </li>
            </ng-container>

            <!-- Large Menu Bottom -->
            <li
                (click)="toggleNavigation()"
                *ngFor="let menuItem of largeMenuBottom"
                appSecurityTag
                [securityTags]="menuItem.securityTags"
                class="nav-item"
                routerLinkActive="{{ menuItem.routerLinkActive }}"
                [routerLinkActiveOptions]="{
                    exact: menuItem.routerLinkActiveExactStatus
                }"
            >
                <a
                    *ngIf="
                        !menuItem.checkVisibility ||
                        (menuItem.checkVisibility && menuItem.visible)
                    "
                    [routerLink]="[menuItem.routerLink]"
                    [id]="menuItem.label === 'layout.sidenav.company-settings' ? 'company-settings-button' : null"
                >
                    <div class="nav-item-inner">
                        <span class="icon-holder"><lucide-icon [name]="menuItem.icon" [size]="20"></lucide-icon></span>
                        <span class="title">
                            {{ menuItem.label | translate }}
                        </span>
                    </div>
                </a>
            </li>
        </ul>
        <div class="in2logo nav-bottom-logo"></div>
    </div>
</div>
